export enum FeatureStrings {
    GiftWrap = 'GiftWrap',
    Giftshop = 'Giftshop',
}
